import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acompanhar-assinaturas',
  templateUrl: './acompanhar-assinaturas.component.html',
  styleUrls: ['./acompanhar-assinaturas.component.scss']
})
export class AcompanharAssinaturasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
